/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum PriceExplainValueBaseTypeApiModel {
  BasePrice = 'base-price',

  SalePrice = 'sale-price',

  PostedPrice = 'posted-price',

  PriceIncludingTaxes = 'price-including-taxes'
}
